import { Home, Building2, Car, MapPin, Truck, Phone } from "lucide-react";
import { FadeUp, MaskLines } from "./Reveal";
import { PHONE_DISPLAY, PHONE_TEL } from "@/lib/api";
import { useLang } from "@/lib/i18n";

const ICONS = [Home, Building2, Car, MapPin];

export const MobileBand = () => {
  const { t } = useLang();
  const m = t.mobile;
  return (
    <section id="mobile" data-testid="mobile-service-section" className="relative overflow-hidden bg-brand2 py-20 text-cream md:py-28">
      <Truck aria-hidden className="pointer-events-none absolute -right-10 -top-10 h-[320px] w-[320px] text-cream/10 md:h-[460px] md:w-[460px]" strokeWidth={1} />
      <div className="relative mx-auto grid max-w-[1440px] gap-12 px-5 md:px-10 lg:grid-cols-12 lg:items-center">
        <div className="lg:col-span-6">
          <span className="inline-flex items-center gap-2 bg-cream px-3 py-1.5 font-mono text-[12px] font-medium uppercase tracking-[0.2em] text-brand2">
            <Truck className="h-4 w-4" /> {m.eyebrow}
          </span>
          <h2 className="font-display mt-8 text-4xl font-black uppercase leading-[0.92] sm:text-5xl lg:text-6xl">
            <MaskLines inView lines={[m.title, <span key="m" className="font-serif-i normal-case">{m.title2}</span>]} />
          </h2>
          <FadeUp>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-cream/90 md:text-lg">{m.body}</p>
            <a data-testid="mobile-band-call" href={PHONE_TEL} className="mt-8 inline-flex items-center gap-3 bg-cream px-7 py-4 text-brand2 transition-transform duration-300 hover:-translate-y-0.5">
              <Phone className="h-4 w-4" />
              <span className="font-display text-sm font-extrabold uppercase tracking-wider">{m.cta} · {PHONE_DISPLAY}</span>
            </a>
          </FadeUp>
        </div>
        <div className="grid grid-cols-2 gap-3 lg:col-span-6">
          {m.places.map((p, i) => {
            const Icon = ICONS[i];
            return (
              <FadeUp key={p} delay={i * 0.08}>
                <div data-testid={`mobile-place-${i}`} className="flex h-full flex-col gap-6 border border-cream/30 p-5 transition-colors duration-500 hover:bg-cream/10 md:p-7">
                  <Icon className="h-7 w-7 text-sun" style={{ color: "#F2C14E" }} />
                  <span className="font-display text-lg font-extrabold uppercase md:text-xl">{p}</span>
                </div>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </section>
  );
};
